"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtils_1 = require("../lib/ArrayUtils");
var Constants = require("./Constants");
var AccountType_1 = require("./AccountType");
var MemberType_1 = require("./MemberType");
var PhaseType_1 = require("./PhaseType");
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var RetirementDrawingsTable_1 = require("./RetirementDrawingsTable");
var _ = require("lodash");
var ZERO_ASSETS_LESS_THAN = 5;
var _2014_1_1 = new Date(2014, 0, 1, 12, 0, 0).getTime();
var _2015_1_1 = new Date(2015, 0, 1, 12, 0, 0).getTime();
var _2017_7_1 = new Date(2017, 6, 1, 12, 0, 0).getTime();
var _2018_7_1 = new Date(2018, 6, 1, 12, 0, 0).getTime();
var _2021_6_30 = new Date(2021, 5, 30, 12, 0, 0);
var _2020_6_30 = new Date(2020, 5, 30, 12, 0, 0);
var Account = (function () {
    function Account() {
        this._dbContributionRate = 0;
        this._dbAccrualRate = 0;
        this._accountBasedPensionPurchasePrice = 0;
        this._lengthOfPeriodInFirstProjectionPeriod = 0.0;
        this._arrayCounter = 1;
        this._InitialCashAllocation = 0;
        this._RemainingCashAllocation = 0;
        this._RemainingCashAssets = 0;
        this._accumulationAssets = [];
        this._pensionAssets = [];
        this._dbMultiple = [];
        this._dbAssets = [];
        this._deferredRetirementAssets = [];
        this._indexedPensionHistory = [];
        this._netContributions = [];
        this._drawings = [];
        this._actualDrawings = [];
        this._accumulationAccountDrawings = [];
        this._pensionAccountDrawings = [];
        this._minimumDrawings = [];
        this._investmentEarnings = [];
        this._administrationFees = [];
        this._insuranceFees = [];
        this._deflationFactor = [];
        this._deflatedPensionAccountDrawings = [];
        this._deflatedAccumulationAccountDrawings = [];
        this._deflatedDrawings = [];
        this._deflatedActualDrawings = [];
        this._deflatedIndexedPension = [];
        this._deflatedMinimumDrawings = [];
        this._deflatedInsuranceFees = [];
        this._grossReturn = [];
        this._taxableFraction = [];
        this._remainingCashAllocationHistory = [];
        this._triedToExceedNonConcessionalContributionCap = false;
        this._ageTriedToExceededNonConcessionalContributionCap = 0;
        this._drawingsLessThanMinimumDrawingRequirements = false;
        this._drawingsAreMinimumLegislated = false;
        this._inPreviousTwoYearsTriggeredBringForwardRule = [];
        this._previousTwoYearsBringForwardPeriod = [];
        this._previousTwoYearsNonConcessionalContributions = [];
        this._previousTwoYearsNonConcessionalContributionsCap = [];
    }
    Account.prototype.initialise = function (p, superannuationBalance, investmentOptionSelected, memberphase, memberAge, superannuationInvestmentOption, initialRateOfIndexedPension, indexedPensionStartAge, limitConcessionalContributionsToThreshold, unTaxedComponent, taxedComponent, wageIndexation, priceIndexation, arraySize, thisMemberType, discountWithPriceInflationInRetirement, useProfileDefaultCashAllocation, initialCashAllocation, cashInvestmentOptionIndex, retirementAge, applyTaxDeductionForExpenses, debugMode) {
        this._arrayCounter = 1;
        this._concessionalContributionThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._nonConcessionalContributionThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._lowIncomeEarnersGovernmentContributionMaximum = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._concessionalContributionThreshold.initialise(p.getParamNumber("ConcessionalContributionThreshold"), wageIndexation);
        this._nonConcessionalContributionThreshold.initialise(p.getParamNumber("NonConcessionalContributionThreshold"), wageIndexation);
        this._lowIncomeEarnersGovernmentContributionIncomeThreshold.initialise(p.getParamNumber("LowIncomeEarnersGovernmentContributionIncomeThreshold"), wageIndexation);
        this._lowIncomeEarnersGovernmentContributionMaximum.initialise(p.getParamNumber("LowIncomeEarnersGovernmentContributionMaximum"), wageIndexation);
        this._highIncomeEarningThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._highIncomeEarningThreshold.initialise(p.getParamNumber("HighIncomeEarningThreshold"), wageIndexation);
        this._pensionTransferBalanceCap = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._pensionTransferBalanceCap.initialise(p.getParamNumber("PensionTransferBalanceCap"), priceIndexation);
        this._pensionTransferBalanceCapExceeded = false;
        this._untaxedPlanCapAmount = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._untaxedPlanCapAmount.initialise(p.getParamNumber("UntaxedPlanCapAmount"), wageIndexation);
        this._indexedPension = new IndexedDollarParameter_1.IndexedDollarParameter();
        if (thisMemberType === MemberType_1.MemberType.ART_RBA ||
            thisMemberType === MemberType_1.MemberType.ART_DEFAULT ||
            thisMemberType === MemberType_1.MemberType.ART_LIFECYCLE) {
            this._indexedPension.initialise(initialRateOfIndexedPension, wageIndexation);
        }
        else {
            this._indexedPension.initialise(initialRateOfIndexedPension, priceIndexation);
        }
        this._indexedPensionStartAge = indexedPensionStartAge;
        this._ExternalDBAssets = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._ExternalDBAssets.initialise(0, wageIndexation);
        this._accumulationAssets = ArrayUtils_1.InitialiseArray(arraySize + 1);
        this._pensionAssets = ArrayUtils_1.InitialiseArray(arraySize + 2);
        this._netContributions = ArrayUtils_1.InitialiseArray(arraySize);
        this._drawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._actualDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._minimumDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._investmentEarnings = ArrayUtils_1.InitialiseArray(arraySize);
        this._administrationFees = ArrayUtils_1.InitialiseArray(arraySize);
        this._insuranceFees = ArrayUtils_1.InitialiseArray(arraySize);
        this._indexedPensionHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._pensionAccountDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._accumulationAccountDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflationFactor = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedAssets = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedAccumulationAssets = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedPensionAssets = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedActualDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedIndexedPension = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedPensionAccountDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedAccumulationAccountDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedMinimumDrawings = ArrayUtils_1.InitialiseArray(arraySize);
        this._deflatedInsuranceFees = ArrayUtils_1.InitialiseArray(arraySize);
        this._grossReturn = ArrayUtils_1.InitialiseArray(arraySize);
        this._taxableFraction = ArrayUtils_1.InitialiseArray(arraySize);
        this._remainingCashAllocationHistory = ArrayUtils_1.InitialiseArray(arraySize);
        this._TaxedComponent = taxedComponent;
        this._cumulativeAmountTransferredFromUntaxedFund = 0;
        this._ttrFirstYear = true;
        var dblUntaxedAssetsToTransfer = 0;
        var dblUntaxedPlanCapAmount = 0;
        var dblTax = 0;
        if ((thisMemberType === MemberType_1.MemberType.SUPERSA_SSS) &&
            (memberphase === PhaseType_1.PhaseType.RETIRED)) {
            dblUntaxedAssetsToTransfer = superannuationBalance - this._TaxedComponent;
            dblUntaxedPlanCapAmount = this.untaxedPlanCapAmountInYear();
            if (dblUntaxedAssetsToTransfer < dblUntaxedPlanCapAmount) {
                dblTax = dblUntaxedAssetsToTransfer * Constants.SUPERANNUATION_TAX_RATE;
            }
            else {
                dblTax =
                    (dblUntaxedPlanCapAmount * Constants.SUPERANNUATION_TAX_RATE) +
                        (dblUntaxedAssetsToTransfer - dblUntaxedPlanCapAmount) * Constants.SUPERANNUATION_EXCESSIVE_TAX_RATE;
            }
            this._cumulativeAmountTransferredFromUntaxedFund = dblUntaxedAssetsToTransfer;
            this._accumulationAssets[this._arrayCounter - 1] = 0;
            this._pensionAssets[this._arrayCounter - 1] = superannuationBalance - dblTax;
            this._ttrFirstYear = false;
            this._TaxedComponent = 0;
            if (debugMode) {
                console.log("SUPERSA_SSS / Retired -> Running Account/initialise()");
                console.info("this._arrayCounter - 1 = ", (this._arrayCounter - 1), "this._cumulativeAmountTransferredFromUntaxedFund =", this._cumulativeAmountTransferredFromUntaxedFund, "this._accumulationAssets =", this._accumulationAssets, "this._pensionAssets =", this._pensionAssets, "this._ttrFirstYear =", this._ttrFirstYear, "this._TaxedComponent =", this._TaxedComponent);
            }
        }
        else {
            this._accumulationAssets[this._arrayCounter - 1] = superannuationBalance;
            if (debugMode) {
                console.log("ALL -> Running Account/initialise() normal code");
                console.info("this._arrayCounter - 1 = ", (this._arrayCounter - 1), "this._accumulationAssets =", this._accumulationAssets, "superannuationBalance", superannuationBalance);
            }
        }
        this._UntaxedComponent = unTaxedComponent;
        this._discountWithPriceInflationInRetirement = discountWithPriceInflationInRetirement;
        this._applyTaxDeductionForExpenses = applyTaxDeductionForExpenses;
        if (memberAge >= this._indexedPensionStartAge) {
            this._indexedPensionHistory[this._arrayCounter - 1] = this._indexedPension.value;
        }
        else {
            this._indexedPensionHistory[this._arrayCounter - 1] = 0;
        }
        this._RetirementIncomeProductPurchasePrice = 0;
        this._previousTwoYearsNonConcessionalContributions[0] = 0;
        this._previousTwoYearsNonConcessionalContributions[1] = 0;
        this._previousTwoYearsNonConcessionalContributionsCap[0] = 0;
        this._previousTwoYearsNonConcessionalContributionsCap[1] = 0;
        this._previousTwoYearsBringForwardPeriod[0] = 0;
        this._previousTwoYearsBringForwardPeriod[1] = 0;
        this._inPreviousTwoYearsTriggeredBringForwardRule[0] = false;
        this._inPreviousTwoYearsTriggeredBringForwardRule[1] = false;
        this._triedToExceedNonConcessionalContributionCap = false;
        this._ageTriedToExceededNonConcessionalContributionCap = 0;
        this._limitConcessionalContributionsToThreshold = limitConcessionalContributionsToThreshold;
        this._triedToExceedConcessionalContributionCap = false;
        this._ageTriedToExceededConcessionalContributionCap = 0;
        this._lengthOfPeriodInFirstProjectionPeriod = 1;
        this._indexedInvestmentOption = _.cloneDeep(superannuationInvestmentOption.getOptionAtPosition(investmentOptionSelected));
        var retirementObj = null;
        switch (thisMemberType) {
            case MemberType_1.MemberType.CSC_Profile1_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile1_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile2_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile2_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile3_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile3_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile4_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile4_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile5_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile5_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile6_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile6_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile7_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile7_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile8_Single_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile8_Single_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile1_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile1_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile2_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile2_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile3_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile3_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile4_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile4_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile5_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile5_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile6_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile6_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile7_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile7_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile8_Couple_Retirement_60:
                retirementObj = p.getParamObject("CSC_Profile8_Couple_Retirement_60");
                break;
            case MemberType_1.MemberType.CSC_Profile1_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile1_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile2_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile2_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile3_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile3_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile4_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile4_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile5_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile5_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile6_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile6_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile7_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile7_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile8_Single_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile8_Single_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile1_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile1_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile2_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile2_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile3_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile3_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile4_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile4_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile5_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile5_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile6_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile6_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile7_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile7_Couple_Retirement_64");
                break;
            case MemberType_1.MemberType.CSC_Profile8_Couple_Retirement_64:
                retirementObj = p.getParamObject("CSC_Profile8_Couple_Retirement_64");
                break;
        }
        this._CSC_RIS_DrawingPercentages = new RetirementDrawingsTable_1.RetirementDrawingsTable();
        if (retirementObj !== null) {
            this._CSC_RIS_DrawingPercentages.initialise(retirementObj.startAge, retirementObj.drawingsPercentage);
        }
        if ((thisMemberType >= MemberType_1.MemberType.CSC_Profile1_Single_Retirement_60) &&
            (thisMemberType <= MemberType_1.MemberType.CSC_Profile8_Couple_Retirement_64)) {
            if (useProfileDefaultCashAllocation) {
                this._InitialCashAllocation = this.CalculateProfileDefaultCashAllocation(this._CSC_RIS_DrawingPercentages, retirementAge);
            }
            else {
                this._InitialCashAllocation = initialCashAllocation;
            }
        }
        this._CashInvestmentOption = superannuationInvestmentOption.getOptionAtPosition(cashInvestmentOptionIndex);
    };
    Account.prototype.CalculateProfileDefaultCashAllocation = function (DrawingTable, RetirementAge) {
        var DefaultCashAllocation;
        DefaultCashAllocation = DrawingTable.getDrawingsPercentage(RetirementAge) + DrawingTable.getDrawingsPercentage(RetirementAge + 1);
        return DefaultCashAllocation;
    };
    Account.prototype.initialiseCovidWithdrawals = function (covidWithdrawal_19_20, covidWithdrawal_20_21, dateProjectionRun) {
        this._covidWithdrawal_19_20 = covidWithdrawal_19_20;
        this._covidWithdrawal_20_21 = covidWithdrawal_20_21;
        this._projectionRunAsAt = dateProjectionRun;
    };
    Account.prototype.initialiseDB = function (accruedDBMultiple, dbContributionRate, salary, accrualRate, arraySize) {
        this._dbMultiple[this._arrayCounter - 1] = accruedDBMultiple;
        this._dbAssets[this._arrayCounter - 1] = this._dbMultiple[this._arrayCounter - 1] * salary;
        this._dbContributionRate = dbContributionRate;
        this._dbAccrualRate = accrualRate;
    };
    Account.prototype.initialiseDeferredRetirement = function (deferredRetirementBalance, memberAge, wageIndexation, arraySize) {
        this._deferredRetirementBalance = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._deferredRetirementBalance.initialise(deferredRetirementBalance, wageIndexation);
        this._deferredRetirementAssets[this._arrayCounter - 1] = this._deferredRetirementBalance.value;
    };
    Account.prototype.SetLengthOfFirstPeriod = function (age_PartYear) {
        this._lengthOfPeriodInFirstProjectionPeriod = 1 - age_PartYear;
    };
    Account.prototype.resetInvestmentChoice = function (investmentOptionSelected, superannuationInvestmentOption) {
        this._indexedInvestmentOption = _.cloneDeep(superannuationInvestmentOption.getOptionAtPosition(investmentOptionSelected));
    };
    Account.prototype.annualUpdate = function (projectionRunAsAt, age, yearCount, isRetired, thisMemberType) {
        var startThisProjectionYear;
        var indexationRate;
        this._arrayCounter = this._arrayCounter + 1;
        startThisProjectionYear = projectionRunAsAt.plus(yearCount - 1);
        if (isRetired) {
            this._dbAccrualRate = 0;
            this._dbMultiple[this._arrayCounter - 1] = 0;
        }
        this._concessionalContributionThreshold.index(yearCount);
        this._nonConcessionalContributionThreshold.index(yearCount);
        this._highIncomeEarningThreshold.index(yearCount);
        this._pensionTransferBalanceCap.index(yearCount);
        this._untaxedPlanCapAmount.index(yearCount);
        this._lowIncomeEarnersGovernmentContributionMaximum.index(yearCount);
        this._indexedInvestmentOption.index(yearCount);
        if (this._indexedPensionStartAge <= age) {
            if ((this._arrayCounter === 2) &&
                ((thisMemberType === MemberType_1.MemberType.ESSS_AssistMe) || (thisMemberType === MemberType_1.MemberType.ESSS_AssistMe_DB))) {
                indexationRate = this._indexedPension.getIndexationInYear(this._arrayCounter);
                this._indexedPension.resetValues(this._indexedPension.value * Math.pow(1 + indexationRate.valueOf(), this._lengthOfPeriodInFirstProjectionPeriod));
                this._indexedPensionHistory[this._arrayCounter - 1] = this._indexedPension.value;
            }
            else {
                this._indexedPensionHistory[this._arrayCounter - 1] = this._indexedPension.value;
                this._indexedPension.index(yearCount);
            }
        }
        else {
            this._indexedPensionHistory[this._arrayCounter - 1] = 0;
        }
        this._ExternalDBAssets.index(yearCount);
    };
    Account.prototype.CalculateRetirementIncomeProductIncome = function (PurchaseProportion, PurchasePrice) {
        var SuperannuationAssetsAtPurchase;
        var BalanceUsedToPurchaseIncomeProduct;
        var InitialRetirementIncomeProductIncome;
        SuperannuationAssetsAtPurchase = this._pensionAssets[this._arrayCounter - 1] + this._accumulationAssets[this._arrayCounter - 1];
        BalanceUsedToPurchaseIncomeProduct = SuperannuationAssetsAtPurchase * PurchaseProportion;
        InitialRetirementIncomeProductIncome = BalanceUsedToPurchaseIncomeProduct / 100000 * PurchasePrice;
        return InitialRetirementIncomeProductIncome;
    };
    Account.prototype.ReduceAccountBalanceForRetirementIncomeProductPurchase = function (PurchaseProportion) {
        this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] * (1 - PurchaseProportion);
        this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] * (1 - PurchaseProportion);
        this._RetirementIncomeProductPurchasePrice = (this._pensionAssets[this._arrayCounter - 1] + this._accumulationAssets[this._arrayCounter - 1]) * (1 - PurchaseProportion);
    };
    Account.prototype.CalculateRetirementIncomeProductIncomeBasedOnAssetConversion = function (PurchaseBalance, PurchasePrice) {
        var SuperannuationAssetsAtPurchase;
        var BalanceUsedToPurchaseIncomeProduct;
        var InitialRetirementIncomeProductIncome;
        SuperannuationAssetsAtPurchase = this._pensionAssets[this._arrayCounter - 1] + this._accumulationAssets[this._arrayCounter - 1];
        BalanceUsedToPurchaseIncomeProduct = Math.min(PurchaseBalance, SuperannuationAssetsAtPurchase);
        InitialRetirementIncomeProductIncome = BalanceUsedToPurchaseIncomeProduct / 100000 * PurchasePrice;
        return InitialRetirementIncomeProductIncome;
    };
    Account.prototype.ReduceAccountBalanceForRetirementIncomeProductPurchase_AssetBasedPurchase = function (PurchasePrice) {
        var DeductionFromAccumulationAssets;
        var DeductionFromPensionAssets;
        DeductionFromAccumulationAssets = Math.min(PurchasePrice, this._accumulationAssets[this._arrayCounter - 1]);
        DeductionFromPensionAssets = Math.min(PurchasePrice - DeductionFromAccumulationAssets, this._pensionAssets[this._arrayCounter - 1]);
        this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] - DeductionFromAccumulationAssets;
        this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] - DeductionFromPensionAssets;
        this._RetirementIncomeProductPurchasePrice = DeductionFromAccumulationAssets + DeductionFromPensionAssets;
    };
    Account.prototype.CalculateMaximumAnnuity = function (PurchasePrice) {
        var SuperannuationAssetsAtPurchase;
        var AssetsForPurchasePrice = 100000;
        SuperannuationAssetsAtPurchase = this._pensionAssets[this._arrayCounter - 1] + this._accumulationAssets[this._arrayCounter - 1];
        return SuperannuationAssetsAtPurchase / AssetsForPurchasePrice * PurchasePrice;
    };
    Account.prototype.setLifeCycleProductInvestmentAssumptions = function (age, superannuationInvestmentOptions) {
        var highRiskInvestmentOption;
        var mediumRiskInvestmentOption;
        var highRiskInvestmentOptionCreditingRate;
        var mediumRiskInvestmentOptionCreditingRate;
        var highRiskInvestmentOptionTaxableFraction;
        var mediumRiskInvestmentOptionTaxableFraction;
        var creditingRate;
        var taxableFraction;
        highRiskInvestmentOption = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(5));
        mediumRiskInvestmentOption = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(3));
        highRiskInvestmentOptionCreditingRate = highRiskInvestmentOption.grossReturn;
        mediumRiskInvestmentOptionCreditingRate = mediumRiskInvestmentOption.grossReturn;
        highRiskInvestmentOptionTaxableFraction = highRiskInvestmentOption.taxableFraction;
        mediumRiskInvestmentOptionTaxableFraction = mediumRiskInvestmentOption.taxableFraction;
        if (age < 50) {
            creditingRate = highRiskInvestmentOptionCreditingRate;
            taxableFraction = highRiskInvestmentOptionTaxableFraction;
        }
        else if (age > 65) {
            creditingRate = mediumRiskInvestmentOptionCreditingRate;
            taxableFraction = mediumRiskInvestmentOptionTaxableFraction;
        }
        else {
            creditingRate = highRiskInvestmentOptionCreditingRate -
                ((highRiskInvestmentOptionCreditingRate - mediumRiskInvestmentOptionCreditingRate) * (age - 50) / 15);
            taxableFraction = highRiskInvestmentOptionTaxableFraction -
                ((highRiskInvestmentOptionTaxableFraction - mediumRiskInvestmentOptionTaxableFraction) * (age - 50) / 15);
        }
        this._indexedInvestmentOption.grossReturn = creditingRate;
        this._indexedInvestmentOption.taxableFraction = taxableFraction;
    };
    Account.prototype.setSunSuperFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var sunSuperFeesInRetirementBasis;
        var feePercentageOnBalance;
        var feePercentageOnBalanceCapped;
        var feePercentageOnBalanceCappedCap;
        var feeAnnualDollar;
        sunSuperFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(6));
        feePercentageOnBalance = sunSuperFeesInRetirementBasis.feePercentageOnBalance;
        feePercentageOnBalanceCapped = sunSuperFeesInRetirementBasis.feePercentageOnBalanceCapped;
        feePercentageOnBalanceCappedCap = sunSuperFeesInRetirementBasis.feePercentageOnBalanceCappedCap;
        feeAnnualDollar = sunSuperFeesInRetirementBasis.feeAnnualDollar;
        this._indexedInvestmentOption.feePercentageOnBalance = (feePercentageOnBalance);
        this._indexedInvestmentOption.feePercentageOnBalanceCapped = (feePercentageOnBalanceCapped);
        this._indexedInvestmentOption.feePercentageOnBalanceCappedCap = (feePercentageOnBalanceCappedCap);
        this._indexedInvestmentOption.feeAnnualDollar = feeAnnualDollar;
    };
    Account.prototype.setAustralianSuperFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var australianSuperFeesInRetirementBasis;
        var feePercentageOnBalance;
        var feePercentageOnBalanceCapped;
        var feePercentageOnBalanceCappedCap;
        var feeAnnualDollar;
        australianSuperFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(5));
        feePercentageOnBalance = australianSuperFeesInRetirementBasis.feePercentageOnBalance;
        feePercentageOnBalanceCapped = australianSuperFeesInRetirementBasis.feePercentageOnBalanceCapped;
        feePercentageOnBalanceCappedCap = australianSuperFeesInRetirementBasis.feePercentageOnBalanceCappedCap;
        feeAnnualDollar = australianSuperFeesInRetirementBasis.feeAnnualDollar;
        this._indexedInvestmentOption.feePercentageOnBalance = (feePercentageOnBalance);
        this._indexedInvestmentOption.feePercentageOnBalanceCapped = (feePercentageOnBalanceCapped);
        this._indexedInvestmentOption.feePercentageOnBalanceCappedCap = (feePercentageOnBalanceCappedCap);
        this._indexedInvestmentOption.feeAnnualDollar = feeAnnualDollar;
    };
    Account.prototype.setVisionFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var visionFeesInRetirementBasis;
        var feePercentageOnBalance;
        var feePercentageOnBalanceCapped;
        var feePercentageOnBalanceCappedCap;
        var feeAnnualDollar;
        visionFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(4));
        feePercentageOnBalance = visionFeesInRetirementBasis.feePercentageOnBalance;
        feePercentageOnBalanceCapped = visionFeesInRetirementBasis.feePercentageOnBalanceCapped;
        feePercentageOnBalanceCappedCap = visionFeesInRetirementBasis.feePercentageOnBalanceCappedCap;
        feeAnnualDollar = visionFeesInRetirementBasis.feeAnnualDollar;
        this._indexedInvestmentOption.feePercentageOnBalance = (feePercentageOnBalance);
        this._indexedInvestmentOption.feePercentageOnBalanceCapped = (feePercentageOnBalanceCapped);
        this._indexedInvestmentOption.feePercentageOnBalanceCappedCap = (feePercentageOnBalanceCappedCap);
        this._indexedInvestmentOption.feeAnnualDollar = feeAnnualDollar;
    };
    Account.prototype.setHostplusFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var hostplusFeesInRetirementBasis;
        var feeAnnualDollar;
        hostplusFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(5));
        feeAnnualDollar = hostplusFeesInRetirementBasis.feeAnnualDollar;
        this._indexedInvestmentOption.feeAnnualDollar = feeAnnualDollar;
    };
    Account.prototype.setSmartMondayFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var smartMondayFeesInRetirementBasis;
        var feePercentageOnBalance;
        smartMondayFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(4));
        feePercentageOnBalance = smartMondayFeesInRetirementBasis.feePercentageOnBalance;
        this._indexedInvestmentOption.feePercentageOnBalance = feePercentageOnBalance;
    };
    Account.prototype.setActiveSuperFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var activeSuperFeesInRetirementBasis;
        var feePercentageOnBalance;
        activeSuperFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(5));
        feePercentageOnBalance = activeSuperFeesInRetirementBasis.feePercentageOnBalance;
        this._indexedInvestmentOption.feePercentageOnBalance = feePercentageOnBalance;
    };
    Account.prototype.setBussQFeeInPensionPhase = function (superannuationInvestmentOptions) {
        var bussQFeesInRetirementBasis;
        var feeAnnualDollar;
        bussQFeesInRetirementBasis = _.cloneDeep(superannuationInvestmentOptions.getOptionAtPosition(4));
        feeAnnualDollar = bussQFeesInRetirementBasis.feeAnnualDollar;
        this._indexedInvestmentOption.feeAnnualDollar = feeAnnualDollar;
    };
    Account.prototype.setFirstStateMySuperInvestmentAssumptions = function (age, superannuationInvestmentOptions) {
        if (age >= 60) {
            this.resetInvestmentChoice(3, superannuationInvestmentOptions);
        }
        else {
            this.resetInvestmentChoice(5, superannuationInvestmentOptions);
        }
    };
    Account.prototype.setActiveSuperLifeCycleInvestmentAssumption = function (age, superannuationInvestmentOptions) {
        if (age < 50) {
            this.resetInvestmentChoice(1, superannuationInvestmentOptions);
        }
        else if (age < 55) {
            this.resetInvestmentChoice(2, superannuationInvestmentOptions);
        }
        else {
            this.resetInvestmentChoice(3, superannuationInvestmentOptions);
        }
    };
    Account.prototype.setGuildLifeCyleInvestmentAssumption = function (age, superannuationInvestmentOptions) {
        if (age < 40) {
            this.resetInvestmentChoice(6, superannuationInvestmentOptions);
        }
        else if (age < 56) {
            this.resetInvestmentChoice(5, superannuationInvestmentOptions);
        }
        else {
            this.resetInvestmentChoice(4, superannuationInvestmentOptions);
        }
    };
    Account.prototype.makeAllAssetsInPensionMode = function (thisMemberType, debugMode) {
        var dblUntaxedAssetsToTransfer;
        var dblTax = 0;
        var dblRemainingUntaxedPlanCapAmount;
        var dblUntaxedPlanCapAmount;
        if (thisMemberType === MemberType_1.MemberType.SUPERSA_SSS) {
            if (this._ttrFirstYear === true) {
                dblUntaxedAssetsToTransfer = this._accumulationAssets[this._arrayCounter - 1] - this._TaxedComponent;
                dblUntaxedPlanCapAmount = this.untaxedPlanCapAmountInYear();
                if (dblUntaxedAssetsToTransfer < dblUntaxedPlanCapAmount) {
                    dblTax = dblUntaxedAssetsToTransfer * Constants.SUPERANNUATION_TAX_RATE;
                }
                else {
                    dblTax = (dblUntaxedPlanCapAmount * Constants.SUPERANNUATION_TAX_RATE) +
                        (dblUntaxedAssetsToTransfer - dblUntaxedPlanCapAmount) *
                            Constants.SUPERANNUATION_EXCESSIVE_TAX_RATE;
                }
                this._cumulativeAmountTransferredFromUntaxedFund = dblUntaxedAssetsToTransfer;
                if (debugMode) {
                    console.log("SUPERSA_SSS -> Running Account/makeAllAssetsInPensionMode() SuperSA.SSS specific code - ttrFirstYear");
                    console.info("dblUntaxedAssetsToTransfer =", dblUntaxedAssetsToTransfer, "dblUntaxedPlanCapAmount =", dblUntaxedPlanCapAmount, "dblTax =", dblTax);
                }
            }
            else {
                dblUntaxedAssetsToTransfer = this._accumulationAssets[this._arrayCounter - 1];
                dblUntaxedPlanCapAmount = this.untaxedPlanCapAmountInYear();
                dblRemainingUntaxedPlanCapAmount = Math.max(dblUntaxedPlanCapAmount - this._cumulativeAmountTransferredFromUntaxedFund, 0);
                if (dblUntaxedAssetsToTransfer < dblRemainingUntaxedPlanCapAmount) {
                    dblTax = dblUntaxedAssetsToTransfer * Constants.SUPERANNUATION_TAX_RATE;
                }
                else {
                    dblTax = (dblRemainingUntaxedPlanCapAmount * Constants.SUPERANNUATION_TAX_RATE) +
                        (dblUntaxedAssetsToTransfer - dblRemainingUntaxedPlanCapAmount) *
                            Constants.SUPERANNUATION_EXCESSIVE_TAX_RATE;
                }
                this._cumulativeAmountTransferredFromUntaxedFund = this._cumulativeAmountTransferredFromUntaxedFund + dblUntaxedAssetsToTransfer;
                if (debugMode) {
                    console.log("SUPERSA_SSS -> Running Account/makeAllAssetsInPensionMode() SuperSA.SSS specific code - NOT ttrFirstYear");
                    console.info("dblUntaxedAssetsToTransfer =", dblUntaxedAssetsToTransfer, "dblUntaxedPlanCapAmount =", dblUntaxedPlanCapAmount, "dblTax =", dblTax);
                }
            }
        }
        this._pensionAssets[this._arrayCounter - 1] =
            this._pensionAssets[this._arrayCounter - 1] +
                this._accumulationAssets[this._arrayCounter - 1] +
                this._dbAssets[this._arrayCounter - 1] +
                this._deferredRetirementAssets[this._arrayCounter - 1] -
                dblTax;
        this._accumulationAssets[this._arrayCounter - 1] = 0;
        this._dbAssets[this._arrayCounter - 1] = 0;
        this._dbMultiple[this._arrayCounter - 1] = 0;
        this._deferredRetirementAssets[this._arrayCounter - 1] = 0;
        this._TaxedComponent = 0;
        this._ttrFirstYear = false;
    };
    Account.prototype.deductTaxAtRetirementOnUntaxedFunds = function () {
        var dblUntaxedAssets;
        var dblUntaxedPlanCapAmount;
        var dblTax;
        dblUntaxedAssets = this._accumulationAssets[this._arrayCounter - 1] - this._TaxedComponent;
        dblUntaxedPlanCapAmount = this.untaxedPlanCapAmountInYear();
        if (dblUntaxedAssets < dblUntaxedPlanCapAmount) {
            dblTax = dblUntaxedAssets * Constants.SUPERANNUATION_TAX_RATE;
        }
        else {
            dblTax =
                (dblUntaxedPlanCapAmount * Constants.SUPERANNUATION_TAX_RATE) +
                    (dblUntaxedAssets - dblUntaxedPlanCapAmount) *
                        Constants.SUPERANNUATION_EXCESSIVE_TAX_RATE;
        }
        this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] - dblTax;
    };
    Account.prototype.transferFundsOnRetirement = function () {
        var dblFundsAvailable = this._pensionAssets[this._arrayCounter - 1] +
            this._accumulationAssets[this._arrayCounter - 1] +
            this._dbAssets[this._arrayCounter - 1] +
            this._deferredRetirementAssets[this._arrayCounter - 1] -
            (this._UntaxedComponent * Constants.SUPERANNUATION_TAX_RATE);
        var dblTransferCap = this.pensionTransferBalanceCapInYear();
        if (dblFundsAvailable > dblTransferCap) {
            this._pensionTransferBalanceCapExceeded = true;
            this._pensionAssets[this._arrayCounter - 1] = dblTransferCap;
            this._accumulationAssets[this._arrayCounter - 1] = dblFundsAvailable - dblTransferCap;
            this._TransferBalanceCapUnusedPercentage = 0;
            this._AssetsTransferredToRetirementAccountAtRetirement = dblTransferCap;
        }
        else {
            this._pensionAssets[this._arrayCounter - 1] = dblFundsAvailable;
            this._accumulationAssets[this._arrayCounter - 1] = 0;
            this._AssetsTransferredToRetirementAccountAtRetirement = dblFundsAvailable;
            this._TransferBalanceCapUnusedPercentage = 1 - (dblFundsAvailable / dblTransferCap);
        }
        this._TransferBalanceCapAtRetirement = dblTransferCap;
        this._dbAssets[this._arrayCounter - 1] = 0;
        this._dbMultiple[this._arrayCounter - 1] = 0;
        this._deferredRetirementAssets[this._arrayCounter - 1] = 0;
    };
    Account.prototype.CalculateCashAllocationOnRetirement = function () {
        this._RemainingCashAllocation = this._InitialCashAllocation;
        this._RemainingCashAssets = (this._pensionAssets[this._arrayCounter - 1] +
            this._accumulationAssets[this._arrayCounter - 1]) * this._InitialCashAllocation;
    };
    Account.prototype.transferDeferredRetirementAssetsToAccumulationAccount = function () {
        this._accumulationAssets[this._arrayCounter - 1] =
            this._accumulationAssets[this._arrayCounter - 1] +
                this._deferredRetirementAssets[this._arrayCounter - 1];
        this._deferredRetirementBalance.resetValues(0);
        this._deferredRetirementAssets[this._arrayCounter - 1] = 0;
    };
    Account.prototype.getMinimumDrawings = function (age, thisMemberType, retiredThisYear, lumpSumWithdrawalAtRetirement) {
        if (retiredThisYear === void 0) { retiredThisYear = false; }
        if (lumpSumWithdrawalAtRetirement === void 0) { lumpSumWithdrawalAtRetirement = 0; }
        var drawingPercentage;
        if ((thisMemberType >= MemberType_1.MemberType.CSC_Profile1_Single_Retirement_60) &&
            (thisMemberType <= MemberType_1.MemberType.CSC_Profile8_Couple_Retirement_64)) {
            drawingPercentage = this._CSC_RIS_DrawingPercentages.getDrawingsPercentage(age);
        }
        else {
            if (age < 65) {
                drawingPercentage = 0.04;
            }
            else if (age <= 74) {
                drawingPercentage = 0.05;
            }
            else if (age <= 79) {
                drawingPercentage = 0.06;
            }
            else if (age <= 84) {
                drawingPercentage = 0.07;
            }
            else if (age <= 89) {
                drawingPercentage = 0.09;
            }
            else if (age <= 94) {
                drawingPercentage = 0.11;
            }
            else {
                drawingPercentage = 0.14;
            }
        }
        if (retiredThisYear) {
            return Math.max(this._pensionAssets[this._arrayCounter - 1] - lumpSumWithdrawalAtRetirement, 0) * drawingPercentage;
        }
        else {
            return this._pensionAssets[this._arrayCounter - 1] * drawingPercentage;
        }
    };
    Account.prototype.getMaximumDrawings = function () {
        var grossRateReturn = this._indexedInvestmentOption.grossReturn;
        var maxDrawings = (this._pensionAssets[this._arrayCounter - 1] + this._accumulationAssets[this._arrayCounter - 1])
            * (1 + grossRateReturn) / (1 + grossRateReturn / 2);
        return Math.floor(maxDrawings);
    };
    Account.prototype.getMaximumTTRDrawings = function () {
        return this._pensionAssets[this._arrayCounter - 1] * Constants.MAXIMUM_TTR_DRAWING_RATE;
    };
    Account.prototype.accumulate = function (preTaxContributions, postTaxMemberContributions, postTaxLumpSumContribution, coContributions, drawings, insurancePremium, age, thisAccountType, thisMemberType, salary, coreContributionsMadePostTax, rollOver, memberPhase, downsizerContribution, debugMode) {
        var accumulationAssetsStartOfYear = 0;
        var pensionAssetsStartOfYear = 0;
        var totalAssetsStartOfYear = 0;
        var netContributions = 0;
        var feeonAccumulationAssets = 0;
        var feeOnPensionAssets = 0;
        var dollarFee = 0;
        var assetFeePercentage = 0;
        var contributionFeePercentage = 0;
        var investmentEarningsOnAccumulationAssets = 0;
        var investmentEarningsOnPensionAssets = 0;
        var averageBalance = 0;
        var cappedFeeOnAssets = 0;
        var cappedFeeOnAccumulationAssets = 0;
        var cappedFeeOnPensionAssets = 0;
        var pensionAccountDrawings = 0;
        var accumulationAccountDrawings = 0;
        var annualNonConcessionalContributionThreshold = 0;
        var transferBalanceCap = 0;
        var futureBringForwardPeriod = 0;
        var thisYearTriggerBringForwardRule = false;
        var nonConcessionalContributionCap = 0;
        var nccPermittedGivenPastTriggersOfBringForwardProvisions = 0;
        var nccPermitted = 0;
        var enforcePastBringForwardProvisions = false;
        var deductibleFees = 0;
        var investmentEarningsForegoneOnCovidWithdrawal = 0;
        var covidWithdrawalInYear = 0;
        var WeightedGrossReturn = 0;
        var WeightedTaxableFraction = 0;
        var PersonalTransferBalanceCap = 0;
        var RemainingTransferBalanceCap = 0;
        if (downsizerContribution > 0) {
            if (memberPhase === PhaseType_1.PhaseType.ACCUMULATION || memberPhase === PhaseType_1.PhaseType.TTR) {
                this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] + downsizerContribution;
            }
            else if (memberPhase === PhaseType_1.PhaseType.RETIRED) {
                PersonalTransferBalanceCap = this._TransferBalanceCapAtRetirement + ((this.pensionTransferBalanceCapInYear() - this._TransferBalanceCapAtRetirement) * this._TransferBalanceCapUnusedPercentage);
                RemainingTransferBalanceCap = PersonalTransferBalanceCap - this._AssetsTransferredToRetirementAccountAtRetirement;
                if (downsizerContribution <= RemainingTransferBalanceCap) {
                    this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] + downsizerContribution;
                }
                else {
                    this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] + RemainingTransferBalanceCap;
                    this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] + (downsizerContribution - RemainingTransferBalanceCap);
                    this._pensionTransferBalanceCapExceeded = true;
                }
            }
        }
        if ((postTaxLumpSumContribution > 0) && (memberPhase === PhaseType_1.PhaseType.RETIRED)) {
            PersonalTransferBalanceCap = this._TransferBalanceCapAtRetirement + ((this.pensionTransferBalanceCapInYear() - this._TransferBalanceCapAtRetirement) * this._TransferBalanceCapUnusedPercentage);
            RemainingTransferBalanceCap = PersonalTransferBalanceCap - this._AssetsTransferredToRetirementAccountAtRetirement;
            if (postTaxLumpSumContribution <= RemainingTransferBalanceCap) {
                this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] + postTaxLumpSumContribution;
            }
            else {
                this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] + RemainingTransferBalanceCap;
                this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] + (postTaxLumpSumContribution - RemainingTransferBalanceCap);
                this._pensionTransferBalanceCapExceeded = true;
            }
            postTaxLumpSumContribution = 0;
        }
        accumulationAssetsStartOfYear = this._accumulationAssets[this._arrayCounter - 1];
        pensionAssetsStartOfYear = this._pensionAssets[this._arrayCounter - 1];
        totalAssetsStartOfYear = accumulationAssetsStartOfYear + pensionAssetsStartOfYear;
        enforcePastBringForwardProvisions = false;
        if (this._inPreviousTwoYearsTriggeredBringForwardRule[0] && (this._previousTwoYearsBringForwardPeriod[0] > 1)) {
            nccPermittedGivenPastTriggersOfBringForwardProvisions = this._previousTwoYearsNonConcessionalContributionsCap[0] -
                this._previousTwoYearsNonConcessionalContributions[0];
            enforcePastBringForwardProvisions = true;
        }
        else if (this._inPreviousTwoYearsTriggeredBringForwardRule[1] && (this._previousTwoYearsBringForwardPeriod[1]) === 3) {
            nccPermittedGivenPastTriggersOfBringForwardProvisions = this._previousTwoYearsNonConcessionalContributionsCap[1] -
                this._previousTwoYearsNonConcessionalContributions[0] - this._previousTwoYearsNonConcessionalContributions[1];
            enforcePastBringForwardProvisions = true;
        }
        annualNonConcessionalContributionThreshold = Math.floor(this._nonConcessionalContributionThreshold.value / 10000) * 10000;
        transferBalanceCap = this.pensionTransferBalanceCapInYear();
        if ((totalAssetsStartOfYear >= transferBalanceCap)) {
            futureBringForwardPeriod = 0;
            nonConcessionalContributionCap = 0;
        }
        else if (((totalAssetsStartOfYear >= (transferBalanceCap - annualNonConcessionalContributionThreshold)) &&
            (totalAssetsStartOfYear < transferBalanceCap)) ||
            (age >= 75)) {
            futureBringForwardPeriod = 1;
            nonConcessionalContributionCap = annualNonConcessionalContributionThreshold;
        }
        else if ((totalAssetsStartOfYear >= (transferBalanceCap - (2 * annualNonConcessionalContributionThreshold))) &&
            (totalAssetsStartOfYear < (transferBalanceCap - annualNonConcessionalContributionThreshold))) {
            futureBringForwardPeriod = 2;
            nonConcessionalContributionCap = annualNonConcessionalContributionThreshold * futureBringForwardPeriod;
        }
        else {
            futureBringForwardPeriod = 3;
            nonConcessionalContributionCap = annualNonConcessionalContributionThreshold * futureBringForwardPeriod;
        }
        if (enforcePastBringForwardProvisions) {
            thisYearTriggerBringForwardRule = false;
            nccPermitted = Math.max(0, Math.min(nccPermittedGivenPastTriggersOfBringForwardProvisions, nonConcessionalContributionCap));
        }
        else {
            if ((postTaxMemberContributions + postTaxLumpSumContribution) > annualNonConcessionalContributionThreshold) {
                thisYearTriggerBringForwardRule = true;
            }
            else {
                thisYearTriggerBringForwardRule = false;
            }
            nccPermitted = nonConcessionalContributionCap;
        }
        if ((postTaxMemberContributions + postTaxLumpSumContribution) > nccPermitted) {
            if (this._triedToExceedNonConcessionalContributionCap === false) {
                this._ageTriedToExceededNonConcessionalContributionCap = age;
            }
            this._triedToExceedNonConcessionalContributionCap = true;
            postTaxMemberContributions = Math.min(postTaxMemberContributions, nccPermitted);
            postTaxLumpSumContribution = Math.min(postTaxLumpSumContribution, nccPermitted - postTaxMemberContributions);
            if ((postTaxMemberContributions + postTaxLumpSumContribution) === 0) {
                coContributions = 0;
            }
        }
        this._previousTwoYearsNonConcessionalContributions[1] = this._previousTwoYearsNonConcessionalContributions[0];
        this._previousTwoYearsNonConcessionalContributions[0] = postTaxMemberContributions + postTaxLumpSumContribution;
        this._previousTwoYearsNonConcessionalContributionsCap[1] = this._previousTwoYearsNonConcessionalContributionsCap[0];
        this._previousTwoYearsNonConcessionalContributionsCap[0] = nonConcessionalContributionCap;
        this._previousTwoYearsBringForwardPeriod[1] = this._previousTwoYearsBringForwardPeriod[0];
        this._previousTwoYearsBringForwardPeriod[0] = futureBringForwardPeriod;
        this._inPreviousTwoYearsTriggeredBringForwardRule[1] = this._inPreviousTwoYearsTriggeredBringForwardRule[0];
        this._inPreviousTwoYearsTriggeredBringForwardRule[0] = thisYearTriggerBringForwardRule;
        if (this._limitConcessionalContributionsToThreshold) {
            var RoundedConcessionalContributionThreshold = Math.floor(this._concessionalContributionThreshold.value / 2500) * 2500;
            if (preTaxContributions > RoundedConcessionalContributionThreshold) {
                preTaxContributions = RoundedConcessionalContributionThreshold;
                if (this._triedToExceedConcessionalContributionCap === false) {
                    this._ageTriedToExceededConcessionalContributionCap = age;
                }
                this._triedToExceedConcessionalContributionCap = true;
            }
        }
        dollarFee = this._indexedInvestmentOption.feeAnnualDollar;
        assetFeePercentage = this._indexedInvestmentOption.feePercentageOnBalance;
        contributionFeePercentage = this._indexedInvestmentOption.feePercentageOnContributions;
        feeonAccumulationAssets =
            (accumulationAssetsStartOfYear * assetFeePercentage) +
                ((preTaxContributions + postTaxMemberContributions + postTaxLumpSumContribution) * contributionFeePercentage);
        feeOnPensionAssets =
            (pensionAssetsStartOfYear * assetFeePercentage);
        if (memberPhase === PhaseType_1.PhaseType.ACCUMULATION) {
            feeonAccumulationAssets = feeonAccumulationAssets + insurancePremium;
        }
        else if (memberPhase === PhaseType_1.PhaseType.TTR) {
            feeOnPensionAssets = feeOnPensionAssets + insurancePremium;
        }
        if (accumulationAssetsStartOfYear !== 0) {
            feeonAccumulationAssets = feeonAccumulationAssets + dollarFee;
        }
        if (pensionAssetsStartOfYear !== 0) {
            feeOnPensionAssets = feeOnPensionAssets + dollarFee;
        }
        if (!(totalAssetsStartOfYear === 0)) {
            cappedFeeOnAssets = totalAssetsStartOfYear * this._indexedInvestmentOption.feePercentageOnBalanceCapped;
            cappedFeeOnAssets = Math.min(cappedFeeOnAssets, this._indexedInvestmentOption.feePercentageOnBalanceCappedCap);
            cappedFeeOnAccumulationAssets = cappedFeeOnAssets * accumulationAssetsStartOfYear / totalAssetsStartOfYear;
            cappedFeeOnPensionAssets = cappedFeeOnAssets - cappedFeeOnAccumulationAssets;
            if (cappedFeeOnPensionAssets < 0.0001) {
                cappedFeeOnPensionAssets = 0;
            }
            feeonAccumulationAssets = feeonAccumulationAssets + cappedFeeOnAccumulationAssets;
            feeOnPensionAssets = feeOnPensionAssets + cappedFeeOnPensionAssets;
        }
        this._administrationFees[this._arrayCounter - 1] = feeonAccumulationAssets + feeOnPensionAssets - insurancePremium;
        if ((memberPhase === PhaseType_1.PhaseType.ACCUMULATION) || (memberPhase === PhaseType_1.PhaseType.TTR)) {
            this._administrationFees[this._arrayCounter - 1] = feeonAccumulationAssets + feeOnPensionAssets - insurancePremium;
        }
        else {
            this._administrationFees[this._arrayCounter - 1] = feeonAccumulationAssets + feeOnPensionAssets;
        }
        if ((memberPhase === PhaseType_1.PhaseType.ACCUMULATION) || (memberPhase === PhaseType_1.PhaseType.TTR)) {
            this._insuranceFees[this._arrayCounter - 1] = insurancePremium;
        }
        else {
            this._insuranceFees[this._arrayCounter - 1] = 0;
        }
        if (memberPhase === PhaseType_1.PhaseType.TTR) {
            deductibleFees = feeOnPensionAssets;
        }
        else {
            deductibleFees = feeonAccumulationAssets;
        }
        netContributions =
            this.netConcessionalContributions(preTaxContributions, deductibleFees, age, thisAccountType, thisMemberType, salary, coreContributionsMadePostTax) +
                this.netNonConcessionalContributions(postTaxMemberContributions, postTaxLumpSumContribution, age, thisAccountType, thisMemberType, coreContributionsMadePostTax, salary) +
                coContributions;
        var blnNeedToCheckAccumulationDrawingsAgainstBalance = false;
        if (drawings === 0) {
            pensionAccountDrawings = 0;
            accumulationAccountDrawings = 0;
        }
        else if (!this._pensionTransferBalanceCapExceeded || accumulationAssetsStartOfYear === 0) {
            pensionAccountDrawings = drawings;
            accumulationAccountDrawings = 0;
        }
        else if (pensionAssetsStartOfYear === 0) {
            pensionAccountDrawings = 0;
            accumulationAccountDrawings = drawings;
        }
        else if (drawings < this.getMinimumDrawings(age, thisMemberType)) {
            pensionAccountDrawings = drawings;
            accumulationAccountDrawings = 0;
        }
        else {
            pensionAccountDrawings = Math.min(drawings, this.getMinimumDrawings(age, thisMemberType));
            accumulationAccountDrawings = drawings - pensionAccountDrawings;
            if (accumulationAccountDrawings > accumulationAssetsStartOfYear) {
                accumulationAccountDrawings = accumulationAssetsStartOfYear;
                pensionAccountDrawings = drawings - accumulationAccountDrawings;
                blnNeedToCheckAccumulationDrawingsAgainstBalance = true;
            }
        }
        averageBalance = accumulationAssetsStartOfYear +
            netContributions / 2 -
            accumulationAccountDrawings / 2 -
            feeonAccumulationAssets / 2;
        if (this._RemainingCashAllocation === 0) {
            if (thisMemberType === MemberType_1.MemberType.SUPERSA_SSS) {
                investmentEarningsOnAccumulationAssets =
                    averageBalance * this._indexedInvestmentOption.grossReturn;
                if (debugMode) {
                    console.log("SUPERSA_SSS -> Running accumulate() SuperSA.SSS specific code");
                    console.info("investmentEarningsOnAccumulationAssets = ", investmentEarningsOnAccumulationAssets);
                }
            }
            else {
                investmentEarningsOnAccumulationAssets =
                    averageBalance * this._indexedInvestmentOption.grossReturn -
                        averageBalance * this._indexedInvestmentOption.grossReturn *
                            this._indexedInvestmentOption.taxableFraction *
                            Constants.SUPERANNUATION_TAX_RATE;
                if (debugMode) {
                    console.log("ALL -> Running accumulate() normal code");
                    console.info("investmentEarningsOnAccumulationAssets = ", investmentEarningsOnAccumulationAssets);
                }
            }
        }
        else {
            WeightedGrossReturn = (this._CashInvestmentOption.grossReturn * this._RemainingCashAllocation) +
                (this._indexedInvestmentOption.grossReturn * (1 - this._RemainingCashAllocation));
            WeightedTaxableFraction = (this._CashInvestmentOption.taxableFraction * this._RemainingCashAllocation) +
                (this._indexedInvestmentOption.taxableFraction * (1 - this._RemainingCashAllocation));
            if (thisMemberType === MemberType_1.MemberType.SUPERSA_SSS) {
                investmentEarningsOnAccumulationAssets = averageBalance * WeightedGrossReturn;
            }
            else {
                investmentEarningsOnAccumulationAssets = averageBalance * WeightedGrossReturn -
                    averageBalance * WeightedGrossReturn *
                        WeightedTaxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
        }
        if (this._projectionRunAsAt.before(_2020_6_30)) {
            if (this._arrayCounter === 1) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_19_20, accumulationAssetsStartOfYear);
                investmentEarningsForegoneOnCovidWithdrawal =
                    covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn -
                        covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn * this._indexedInvestmentOption.taxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
            else if (this._arrayCounter === 2) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_20_21, accumulationAssetsStartOfYear);
                investmentEarningsForegoneOnCovidWithdrawal =
                    covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn -
                        covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn * this._indexedInvestmentOption.taxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
        }
        else if (this._projectionRunAsAt.before(_2021_6_30)) {
            if (this._arrayCounter === 1) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_20_21, accumulationAssetsStartOfYear);
                investmentEarningsForegoneOnCovidWithdrawal =
                    covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn -
                        covidWithdrawalInYear * this._indexedInvestmentOption.grossReturn * this._indexedInvestmentOption.taxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
        }
        investmentEarningsOnAccumulationAssets = investmentEarningsOnAccumulationAssets - investmentEarningsForegoneOnCovidWithdrawal;
        if (blnNeedToCheckAccumulationDrawingsAgainstBalance) {
            accumulationAccountDrawings = accumulationAssetsStartOfYear + netContributions + investmentEarningsOnAccumulationAssets - feeonAccumulationAssets;
            pensionAccountDrawings = drawings - accumulationAccountDrawings;
        }
        averageBalance = pensionAssetsStartOfYear - pensionAccountDrawings / 2 - feeOnPensionAssets / 2;
        if (this._RemainingCashAllocation === 0) {
            if (memberPhase === PhaseType_1.PhaseType.TTR) {
                investmentEarningsOnPensionAssets =
                    averageBalance * this._indexedInvestmentOption.grossReturn -
                        averageBalance * this._indexedInvestmentOption.grossReturn *
                            this._indexedInvestmentOption.taxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
            else {
                investmentEarningsOnPensionAssets =
                    averageBalance * this._indexedInvestmentOption.grossReturn;
            }
        }
        else {
            WeightedGrossReturn = (this._CashInvestmentOption.grossReturn * this._RemainingCashAllocation) +
                (this._indexedInvestmentOption.grossReturn * (1 - this._RemainingCashAllocation));
            WeightedTaxableFraction = (this._CashInvestmentOption.taxableFraction * this._RemainingCashAllocation) +
                (this._indexedInvestmentOption.taxableFraction * (1 - this._RemainingCashAllocation));
            if (memberPhase === PhaseType_1.PhaseType.TTR) {
                investmentEarningsOnPensionAssets = averageBalance * WeightedGrossReturn -
                    averageBalance * WeightedGrossReturn * WeightedTaxableFraction * Constants.SUPERANNUATION_TAX_RATE;
            }
            else {
                investmentEarningsOnPensionAssets = averageBalance * WeightedGrossReturn;
            }
        }
        this._remainingCashAllocationHistory[this._arrayCounter] = this._RemainingCashAllocation;
        if (((thisMemberType === MemberType_1.MemberType.ESSS_AssistMe) || (thisMemberType === MemberType_1.MemberType.ESSS_AssistMe_DB)) &&
            (this._arrayCounter === 1)) {
            netContributions = ((netContributions - postTaxLumpSumContribution) * this._lengthOfPeriodInFirstProjectionPeriod) + postTaxLumpSumContribution;
            accumulationAccountDrawings = accumulationAccountDrawings * this._lengthOfPeriodInFirstProjectionPeriod;
            feeonAccumulationAssets = feeonAccumulationAssets * this._lengthOfPeriodInFirstProjectionPeriod;
            investmentEarningsOnAccumulationAssets = investmentEarningsOnAccumulationAssets * this._lengthOfPeriodInFirstProjectionPeriod;
        }
        this._accumulationAssets[this._arrayCounter] = accumulationAssetsStartOfYear + netContributions -
            accumulationAccountDrawings - feeonAccumulationAssets + investmentEarningsOnAccumulationAssets;
        if (this._projectionRunAsAt.before(_2020_6_30)) {
            if (this._arrayCounter === 1) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_19_20, accumulationAssetsStartOfYear);
            }
            else if (this._arrayCounter === 2) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_20_21, accumulationAssetsStartOfYear);
            }
        }
        else if (this._projectionRunAsAt.before(_2021_6_30)) {
            if (this._arrayCounter === 1) {
                covidWithdrawalInYear = Math.min(this._covidWithdrawal_20_21, accumulationAssetsStartOfYear);
            }
        }
        else {
            covidWithdrawalInYear = 0;
        }
        this._accumulationAssets[this._arrayCounter] = this._accumulationAssets[this._arrayCounter] - covidWithdrawalInYear;
        this._accumulationAssets[this._arrayCounter] = Math.max(0, this._accumulationAssets[this._arrayCounter]);
        this._accumulationAssets[this._arrayCounter] = this._accumulationAssets[this._arrayCounter] + rollOver;
        var pensionAssets;
        var actualDrawings;
        pensionAssets = pensionAssetsStartOfYear - pensionAccountDrawings - feeOnPensionAssets + investmentEarningsOnPensionAssets;
        actualDrawings = drawings;
        if (pensionAssets < 5) {
            actualDrawings = Math.max(0, actualDrawings + pensionAssets);
            pensionAccountDrawings = Math.max(0, pensionAccountDrawings + pensionAssets);
            pensionAssets = 0;
        }
        this._pensionAssets[this._arrayCounter] = pensionAssets;
        this._actualDrawings[this._arrayCounter - 1] = actualDrawings;
        this._pensionAccountDrawings[this._arrayCounter - 1] = pensionAccountDrawings;
        this._accumulationAccountDrawings[this._arrayCounter - 1] = accumulationAccountDrawings;
        this._investmentEarnings[this._arrayCounter - 1] = investmentEarningsOnAccumulationAssets + investmentEarningsOnPensionAssets;
        this._grossReturn[this._arrayCounter - 1] = this._indexedInvestmentOption.grossReturn;
        this._taxableFraction[this._arrayCounter - 1] = this._indexedInvestmentOption.taxableFraction;
        if (this._accumulationAssets[this._arrayCounter] + this._pensionAssets[this._arrayCounter] < ZERO_ASSETS_LESS_THAN) {
            this._accumulationAssets[this._arrayCounter] = 0;
            this._pensionAssets[this._arrayCounter] = 0;
        }
        if (((memberPhase === PhaseType_1.PhaseType.RETIRED) &&
            (this._RemainingCashAssets > 0)) && ((this._pensionAssets[this._arrayCounter] > 0) ||
            (this._accumulationAssets[this._arrayCounter] > 0))) {
            var ProportionInPensionPhase = void 0;
            var CashReturn = void 0;
            ProportionInPensionPhase = this._pensionAssets[this._arrayCounter] /
                (this._pensionAssets[this._arrayCounter] + this._accumulationAssets[this._arrayCounter]);
            CashReturn = ((this._CashInvestmentOption.grossReturn * ProportionInPensionPhase) + ((this._CashInvestmentOption.grossReturn *
                (1 - this._CashInvestmentOption.taxableFraction) *
                (1 - ProportionInPensionPhase))));
            this._RemainingCashAssets = Math.max((this._RemainingCashAssets * (1 + CashReturn) -
                drawings * Math.pow(1 + CashReturn, 0.5) -
                (feeOnPensionAssets * this._RemainingCashAssets / this._pensionAssets[this._arrayCounter] * Math.pow(1 + CashReturn, 0.5))), 0);
            this._RemainingCashAllocation = this._RemainingCashAssets / (this._accumulationAssets[this._arrayCounter] + this._pensionAssets[this._arrayCounter]);
        }
        else {
            this._RemainingCashAssets = 0;
            this._RemainingCashAllocation = 0;
        }
    };
    Account.prototype.accrueDBAndDeferredRetirement = function (salary, midYearSalary, workload) {
        var salaryInflation;
        if (salary === 0) {
            salaryInflation = 0;
        }
        else {
            salaryInflation = ((midYearSalary / salary) - 1) * 2;
        }
        this._dbMultiple[this._arrayCounter] = this._dbMultiple[this._arrayCounter - 1] + (this._dbAccrualRate * workload);
        this._dbAssets[this._arrayCounter] = this._dbMultiple[this._arrayCounter] * (salary * (1 + salaryInflation));
        this._deferredRetirementBalance.index(1);
        this._deferredRetirementAssets[this._arrayCounter] = this._deferredRetirementBalance.value;
    };
    Account.prototype.withdraw = function (amountToWithdraw) {
        this._pensionAssets[this._arrayCounter - 1] = this._pensionAssets[this._arrayCounter - 1] - amountToWithdraw;
    };
    Account.prototype.netConcessionalContributions = function (concessionalContributions, fees, age, thisAccountType, thisMemberType, salary, coreContributionsMadePostTax) {
        var concessionalContributionThreshold;
        var taxableContributions;
        var tax;
        concessionalContributionThreshold = this._concessionalContributionThreshold.value;
        concessionalContributionThreshold = Math.floor(concessionalContributionThreshold / 2500) * 2500;
        if (thisAccountType === AccountType_1.AccountType.DEFINED_BENEFIT) {
            if (thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT && coreContributionsMadePostTax) {
                concessionalContributionThreshold = concessionalContributionThreshold -
                    1.2 * ((0.12 * salary) - salary * this._dbContributionRate);
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_POLICE && coreContributionsMadePostTax) {
                concessionalContributionThreshold = concessionalContributionThreshold -
                    1.2 * ((0.14 * salary) - salary * this._dbContributionRate);
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT && !coreContributionsMadePostTax) {
                concessionalContributionThreshold = concessionalContributionThreshold -
                    1.2 * (0.12 * salary);
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_POLICE && !coreContributionsMadePostTax) {
                concessionalContributionThreshold = concessionalContributionThreshold -
                    1.2 * (0.14 * salary);
            }
        }
        if (this._applyTaxDeductionForExpenses) {
            taxableContributions = Math.max(0, concessionalContributions - fees);
        }
        else {
            taxableContributions = concessionalContributions;
        }
        if (thisMemberType === MemberType_1.MemberType.SUPERSA_SSS) {
            if ((salary + taxableContributions) < this._highIncomeEarningThreshold.value) {
                tax = 0;
            }
            else if (salary > this._highIncomeEarningThreshold.value) {
                tax = taxableContributions * Constants.SUPERANNUATION_TAX_RATE;
            }
            else {
                tax = (salary + taxableContributions - this._highIncomeEarningThreshold.value) * Constants.SUPERANNUATION_TAX_RATE;
            }
        }
        else {
            if ((salary + taxableContributions) < this._highIncomeEarningThreshold.value) {
                tax = taxableContributions * Constants.SUPERANNUATION_TAX_RATE;
            }
            else if (salary > this._highIncomeEarningThreshold.value) {
                tax = taxableContributions * Constants.SUPERANNUATION_TAX_RATE_HIGH_EARNER;
            }
            else {
                tax = ((this._highIncomeEarningThreshold.value - salary) * Constants.SUPERANNUATION_TAX_RATE) +
                    ((salary + taxableContributions - this._highIncomeEarningThreshold.value) * Constants.SUPERANNUATION_TAX_RATE_HIGH_EARNER);
            }
        }
        if (salary < this._lowIncomeEarnersGovernmentContributionIncomeThreshold.value) {
            tax = Math.max(0, tax - this._lowIncomeEarnersGovernmentContributionMaximum.value);
        }
        return concessionalContributions - tax;
    };
    Account.prototype.netNonConcessionalContributions = function (nonConcessionalContributions, postTaxLumpSumContribution, age, thisAccountType, thisMemberType, coreContributionsMadePostTax, salary) {
        var nonConcessionalContributionThreshold;
        var tax;
        var DBNonConcessionalContribution;
        var rollForwardNumberOfYears = 3;
        nonConcessionalContributionThreshold = this._nonConcessionalContributionThreshold.value;
        nonConcessionalContributionThreshold = Math.floor(nonConcessionalContributionThreshold / 10000) * 10000 * rollForwardNumberOfYears;
        if (thisAccountType === AccountType_1.AccountType.DEFINED_BENEFIT && coreContributionsMadePostTax && (!(thisMemberType === MemberType_1.MemberType.AGEST))) {
            DBNonConcessionalContribution = (salary * this._dbContributionRate);
        }
        else {
            DBNonConcessionalContribution = 0;
        }
        if ((nonConcessionalContributions + postTaxLumpSumContribution + DBNonConcessionalContribution) > nonConcessionalContributionThreshold) {
            tax = (nonConcessionalContributions + postTaxLumpSumContribution + DBNonConcessionalContribution - nonConcessionalContributionThreshold) * Constants.SUPERANNUATION_EXCESSIVE_TAX_RATE;
        }
        else {
            tax = 0;
        }
        return nonConcessionalContributions + postTaxLumpSumContribution - tax;
    };
    Account.prototype.pensionTransferBalanceCapInYear = function () {
        return Math.floor(this._pensionTransferBalanceCap.value / 100000) * 100000;
    };
    Account.prototype.untaxedPlanCapAmountInYear = function () {
        return Math.floor(this._untaxedPlanCapAmount.value / 5000) * 5000;
    };
    Account.prototype.calculateAccountBasedPensionPurchasePrice = function (lifeExpectancy) {
        this._accountBasedPensionPurchasePrice =
            (this._accumulationAssets[this._arrayCounter - 1] + this._pensionAssets[this._arrayCounter - 1]) / lifeExpectancy;
    };
    Account.prototype.isNotExhausted = function () {
        if (((this._accumulationAssets[this._arrayCounter] + this._pensionAssets[this._arrayCounter]) <= 100) && this._arrayCounter > 2) {
            return false;
        }
        else {
            return true;
        }
    };
    Account.prototype.rollOverAmountIn = function (rolloverAmount) {
        this._accumulationAssets[this._arrayCounter - 1] = this._accumulationAssets[this._arrayCounter - 1] + rolloverAmount;
    };
    Account.prototype.deflate = function (wageInflation, priceInflation, thisMemberType, startAge, retirementAge) {
        var wageDeflationFactor = 1;
        var artDeflationFactor = 1;
        var discountRateInYear = 0;
        var deflationFactor = 1;
        var age = startAge + 1;
        this._deflatedAssets[0] = this._accumulationAssets[0] + this._pensionAssets[0] +
            this._dbAssets[0] + this._deferredRetirementAssets[0];
        this._deflatedAccumulationAssets[0] = this._accumulationAssets[0];
        this._deflatedPensionAssets[0] = this._pensionAssets[0];
        this._deflatedDrawings[0] = this._drawings[0];
        this._deflatedActualDrawings[0] = this._actualDrawings[0];
        this._deflatedMinimumDrawings[0] = this._minimumDrawings[0];
        this._deflatedIndexedPension[0] = this._indexedPensionHistory[0];
        this._deflatedPensionAccountDrawings[0] = this._pensionAccountDrawings[0];
        this._deflatedAccumulationAccountDrawings[0] = this._accumulationAccountDrawings[0];
        this._deflatedInsuranceFees[0] = this._insuranceFees[0];
        for (var i = 2; i <= this._drawings.length; i++) {
            if ((age > retirementAge) && (this._discountWithPriceInflationInRetirement === true)) {
                discountRateInYear = priceInflation.getIndexationRate(i - 1);
            }
            else {
                discountRateInYear = wageInflation.getIndexationRate(i - 1);
            }
            if (((thisMemberType === MemberType_1.MemberType.ESSS_AssistMe) ||
                (thisMemberType === MemberType_1.MemberType.ESSS_AssistMe_DB)) && (i === 2)) {
                deflationFactor = Math.pow((deflationFactor / (1 + discountRateInYear)), this._lengthOfPeriodInFirstProjectionPeriod);
            }
            else {
                deflationFactor = deflationFactor / (1 + discountRateInYear);
            }
            this._deflatedAssets[i - 1] = (this._accumulationAssets[i - 1] +
                this._pensionAssets[i - 1] +
                this._dbAssets[i - 1] +
                this._deferredRetirementAssets[i - 1]) * deflationFactor;
            this._deflatedAccumulationAssets[i - 1] = this._accumulationAssets[i - 1] * deflationFactor;
            this._deflatedPensionAssets[i - 1] = this._pensionAssets[i - 1] * deflationFactor;
            this._deflatedDrawings[i - 1] = this._drawings[i - 1] * deflationFactor;
            this._deflatedActualDrawings[i - 1] = this._actualDrawings[i - 1] * deflationFactor;
            this._deflatedIndexedPension[i - 1] = this._indexedPensionHistory[i - 1] * deflationFactor;
            this._deflatedPensionAccountDrawings[i - 1] = this._pensionAccountDrawings[i - 1] * deflationFactor;
            this._deflatedAccumulationAccountDrawings[i - 1] = this._accumulationAccountDrawings[i - 1] * deflationFactor;
            this._deflatedMinimumDrawings[i - 1] = this._minimumDrawings[i - 1] * deflationFactor;
            this._deflatedInsuranceFees[i - 1] = this._insuranceFees[i - 1] * deflationFactor;
            age++;
        }
    };
    Account.prototype.getAccumulationAssetsInYear = function (year) {
        return this._accumulationAssets[year - 1];
    };
    Account.prototype.getPensionAssetsInYear = function (year) {
        return this._pensionAssets[year - 1];
    };
    Account.prototype.currentBalance = function () {
        return this._accumulationAssets[this._arrayCounter - 1] + this._pensionAssets[this._arrayCounter - 1] +
            this._dbAssets[this._arrayCounter - 1] + this._deferredRetirementAssets[this._arrayCounter - 1];
    };
    Account.prototype.currentRateOfIndexedPension = function () {
        return this._indexedPensionHistory[this._arrayCounter - 1];
    };
    Account.prototype.applyDrawingsLimits = function () {
        this._drawings[this._arrayCounter - 1] = Math.min(this._drawings[this._arrayCounter - 1], this.getMaximumDrawings());
    };
    Account.prototype.setDrawings = function (drawings) {
        this._drawings[this._arrayCounter - 1] = drawings;
    };
    Account.prototype.setWhetherDrawingsLessThanMinimum = function (drawingsLessThanMinimum) {
        this._drawingsLessThanMinimumDrawingRequirements = drawingsLessThanMinimum;
    };
    Account.prototype.setWhetherDrawingsAreMinimumLegislated = function (drawingsAreMinimumLegislated) {
        this._drawingsAreMinimumLegislated = drawingsAreMinimumLegislated;
    };
    Account.prototype.setMinimumDrawings = function (minimumDrawings) {
        this._minimumDrawings[this._arrayCounter - 1] = minimumDrawings;
    };
    Account.prototype.addWithdrawalToDrawings = function (withdrawal) {
        this._drawings[this._arrayCounter - 1] = this._drawings[this._arrayCounter - 1] + withdrawal;
        this.applyDrawingsLimits();
    };
    Account.prototype.drawings = function () {
        return this._drawings[this._arrayCounter - 1];
    };
    Account.prototype.getDrawingsInYear = function (year) {
        var result = this._drawings[year - 1];
        return result;
    };
    Account.prototype.getAccruedDBMultipleInYear = function (year) {
        return this._dbMultiple[year - 1];
    };
    Account.prototype.getDBAssetsInYear = function (year) {
        return this._dbAssets[year - 1];
    };
    Account.prototype.getDrawingsFromAccumulationAccountInYear = function (year) {
        return this._accumulationAccountDrawings[year - 1];
    };
    Account.prototype.getDrawingsFromPensionAccountInYear = function (year) {
        return this._pensionAccountDrawings[year - 1];
    };
    Account.prototype.getDeferredRetirementAssetsInYear = function (year) {
        return this._deferredRetirementAssets[year - 1];
    };
    Account.prototype.getDeflationFactorInYear = function (year) {
        return this._deflationFactor[year - 1];
    };
    Account.prototype.getInsuranceFeesInYear = function (year) {
        return this._insuranceFees[year - 1];
    };
    Account.prototype.getAdministrationFeesInYear = function (year) {
        return this._administrationFees[year - 1];
    };
    Account.prototype.getDeflatedAssetsInYear = function (year) {
        return this._deflatedAssets[year - 1];
    };
    Account.prototype.getDeflatedAccumulationAssetsInYear = function (year) {
        return this._deflatedAccumulationAssets[year - 1];
    };
    Account.prototype.getDeflatedPensionAssetsInYear = function (year) {
        return this._deflatedPensionAssets[year - 1];
    };
    Account.prototype.getDeflatedDrawingsInYear = function (year) {
        return this._deflatedDrawings[year - 1];
    };
    Account.prototype.getDeflatedActualDrawingsInYear = function (year) {
        return this._deflatedActualDrawings[year - 1];
    };
    Account.prototype.getDeflatedAccumulationAccountDrawingsInYear = function (year) {
        return this._deflatedAccumulationAccountDrawings[year - 1];
    };
    Account.prototype.getDeflatedPensionAccountDrawingsInYear = function (year) {
        return this._deflatedPensionAccountDrawings[year - 1];
    };
    Account.prototype.getDeflatedMinimumDrawingsInYear = function (year) {
        return this._deflatedMinimumDrawings[year - 1];
    };
    Account.prototype.getDeflatedInsuranceFeesInYear = function (year) {
        return this._deflatedInsuranceFees[year - 1];
    };
    Object.defineProperty(Account.prototype, "indexedPensionIncome", {
        get: function () {
            return this._indexedPensionHistory[this._arrayCounter - 1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "accountBasedPensionPurchasePrice", {
        get: function () {
            return this._accountBasedPensionPurchasePrice;
        },
        enumerable: true,
        configurable: true
    });
    Account.prototype.getIndexedPensionInYear = function (yearCount) {
        return this._indexedPensionHistory[yearCount - 1];
    };
    Account.prototype.getDeflatedIndexedPensionInYear = function (yearCount) {
        return this._deflatedIndexedPension[yearCount - 1];
    };
    Account.prototype.isPensionTransferBalanceCapExceeded = function () {
        return this._pensionTransferBalanceCapExceeded;
    };
    Object.defineProperty(Account.prototype, "triedToExceedNonConcessionalContributionCap", {
        get: function () {
            return this._triedToExceedNonConcessionalContributionCap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "ageTriedToExceedNonConcessionalContributionCap", {
        get: function () {
            return this._ageTriedToExceededNonConcessionalContributionCap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "ExternalDBAssets", {
        get: function () {
            return this._ExternalDBAssets.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "drawingsLessThanMinimumRequired", {
        get: function () {
            return this._drawingsLessThanMinimumDrawingRequirements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "drawingsAreMinimumLegislated", {
        get: function () {
            return this._drawingsAreMinimumLegislated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "RetirementIncomeProductPurchasePrice", {
        get: function () {
            return this._RetirementIncomeProductPurchasePrice;
        },
        enumerable: true,
        configurable: true
    });
    return Account;
}());
exports.Account = Account;
//# sourceMappingURL=Account.js.map